exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-info {\n  border-radius: 0px;\n  margin-top: 15px;\n  margin-bottom: -10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/SPA/src/app/account/sign-in/sign-in.component.scss
// module id = ../../../../../src/app/account/sign-in/sign-in.component.scss
// module chunks = 0